import { findRef } from "./findRef.js";
var findRefByLabel = function findRefByLabel(refs, label) {
  return findRef(refs, function (ref) {
    return ref.label === label;
  });
};
export { findRefByLabel };